import { IGetInformacoesBancariasFuncionarioByIdUseCase } from "../../../presentation/useCases/read/get_informacoes_bancarias_funcionario_by_id_use_case";
import { InformacoesBancarias } from "../../models/informacoes_bancarias";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetInformacoesBancariasFuncionarioByIdUseCase
 */

export class GetInformacoesBancariasFuncionarioByIdUseCase implements IGetInformacoesBancariasFuncionarioByIdUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async getInformacoesBancariasFuncionarioById(idFuncionario: number): Promise<InformacoesBancarias | null> {
    return this.repository.getInformacoesBancariasFuncionarioById(idFuncionario);

  }
}
